import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";
import CTAButton from "./CTAButton";
import OptimizedImage from "./OptimizedImage";
import project1 from "@/assets/project-1.webp";
import project2 from "@/assets/project-2.webp";
import project3 from "@/assets/project-3.webp";

const works = [
  { image: project1, caption: "Sostituzione infissi PVC — Roma", alt: "infissi PVC Roma prima dopo" },
  { image: project2, caption: "Alluminio effetto legno — Guidonia", alt: "alluminio effetto legno Guidonia" },
  { image: project3, caption: "Grata su misura — Villa", alt: "grate su misura villa Roma" },
];

const GallerySection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} className="section-light py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-section-light-foreground">
            Lavori reali (prima/dopo)
          </h2>
          <p className="mt-4 text-section-light-foreground/60 font-body">
            Esempi tra Roma, Guidonia e zone limitrofe.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {works.map((work, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 60 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: i * 0.2 }}
              className="group relative overflow-hidden rounded-sm cursor-pointer"
            >
              <OptimizedImage
                src={work.image}
                alt={work.alt}
                className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
                <span className="font-body text-sm text-white">{work.caption}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-12"
        >
          <CTAButton className="cta-button-light hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300" />
        </motion.div>
      </div>
    </section>
  );
};

export default GallerySection;